import { SearchIcon } from 'lucide-react';
import type { PropsWithChildren } from 'react';
import { isMacOs, isWindows } from 'react-device-detect';
import { Button } from '../../../components/ui/button.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { cn } from '../../../lib/utils.ts';
import { getShortcutKey } from '../utils/get-shortcut-key.ts';
import { useGlobalSearch } from './global-search-bar-provider.tsx';

type Props = {
    showFullInput?: boolean;
    showShortcutKey?: boolean;
    className?: string;
} & PropsWithChildren;

function GlobalSearchBar({ showFullInput = true, showShortcutKey = true, className = '' }: Props) {
    const { t, locale } = useLocale();

    const { openSearch, open } = useGlobalSearch();

    const shortcutKey = getShortcutKey({ isMacOs, isWindows, locale });

    return (
        <div className={cn(showFullInput ? 'w-full' : '', className)}>
            {showFullInput ? (
                <Button
                    className="w-full bg-white border"
                    variant="ghost"
                    selected={open}
                    onClick={() => {
                        openSearch();
                    }}
                >
                    <SearchIcon className="h-4 w-4" />
                    <span className="mr-auto">{t('search')}</span>
                    {showShortcutKey && <span className="rounded-md border px-1">{shortcutKey}</span>}
                </Button>
            ) : (
                <Button
                    size="icon-s"
                    variant="ghost"
                    selected={open}
                    onClick={() => {
                        openSearch();
                    }}
                >
                    <SearchIcon className="flex h-4 w-4 shrink-0" />
                </Button>
            )}
        </div>
    );
}

export { GlobalSearchBar };
